import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import '../Firebase/FirebaseService';
import { getCurrentTimeStamp } from '../../helpers/inbdeUtils';
import { projectName } from '../../helpers/constants';
import { isIterableArray } from '../../helpers/utils';

const randomExports = firebase.firestore().collection('random_exports');
const storage = firebase.storage();
const storageRef = storage.ref();

const pastExportsLimit = 5000;

// only the fields the table reads: the signed in user also carries a Google id
// token, which has no business being written to the database
const getCreator = user => ({
  uid: (user && user.uid) || null,
  displayName: (user && user.displayName) || '',
  email: (user && user.email) || ''
});

const getDefaultName = questionCount =>
  questionCount + (questionCount === 1 ? ' random question' : ' random questions');

/*
A row per exported random set, so an archive that is already in storage can be
found and downloaded again instead of being written once and then lost.

The rows are tagged with the project because DDS and Dental Hygiene share one
database, the same way the reports collection is.
*/
class RandomExportService {
  async getPastRandomExports() {
    try {
      const collection = await randomExports
        .where('project', '==', projectName)
        .orderBy('created_at', 'desc')
        .limit(pastExportsLimit)
        .get();

      return collection.docs.map(doc => ({ ...doc.data(), id: doc.id }));
    } catch (e) {
      console.error('Error reading the random_exports collection from Firestore:', e);
      return null;
    }
  }

  async getRandomExportDownloadUrl(path) {
    if (!path) {
      return null;
    }

    try {
      const downloadUrl = await storageRef.child(path).getDownloadURL();
      return downloadUrl;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async saveRandomExportToFirestore(exportId, randomExport) {
    const { createdBy, filters, format, keywords, name, path, questionCount, url } = randomExport;

    try {
      const randomExportDoc = {
        name: name && name.trim() ? name.trim() : getDefaultName(questionCount),
        created_at: getCurrentTimeStamp(),
        created_by: getCreator(createdBy),
        question_count: questionCount,
        format,
        filters: isIterableArray(filters) ? filters : [],
        keywords: typeof keywords === 'string' ? keywords : '',
        path: path || null,
        url: url || null,
        project: projectName
      };

      await randomExports.doc(exportId).set(randomExportDoc);
      randomExportDoc['id'] = exportId;

      return randomExportDoc;
    } catch (e) {
      console.error('Error saving the exported set to the random_exports collection in Firestore:', e);
      return null;
    }
  }
}

export default RandomExportService;
